import { withCriteriaProvider } from './makeCriteriaProvider';
import useSearchableProgramsWithHasMore from './useSearchablePrograms';

export const makeCriteriaProvider = (tag, context) =>
  withCriteriaProvider(tag, context, useSearchableProgramsWithHasMore);
export { withCriteriaProvider } from './makeCriteriaProvider';
